module.exports = __webpack_public_path__ + "img/Truvito.ff2da2c3.svg";